import BaseModel from '../vendor/baseModel'

export class SearchUser extends BaseModel {
  constructor() {
    super({
      url: 'users',
      name: 'user',
      text: {
        itemTitle: 'Пользователь',
        listTitle: 'Пользователи'
      },
      default: {
        id: null,
        phone: '',
        first_name: '',
        outlets: [],
        user_type: 1,
        password: null
      },
      searchList: [],
      pagination: {
        page_size: 50
      },
      filters: {
        search: null,
        user_type: null,
        detail_data: true,
        ordering: null
      },
      sexItems: [
        {
          title: 'Мужской',
          value: 'male'
        },
        {
          title: 'Женский',
          value: 'female'
        }
      ],
      routes: []
    })
    ;(this.userTypeEnum = {
      CUSTOMER: 1,
      OWNER: 2,
      WORKER: 3,
      COURIER: 4,
      MANAGER: 5,
      DELIVERY_MANAGER: 6
    }),
      (this.userTypeName = {
        [this.userTypeEnum.CUSTOMER]: 'Покупатель',
        [this.userTypeEnum.OWNER]: 'Владелец',
        [this.userTypeEnum.WORKER]: 'Работник',
        [this.userTypeEnum.COURIER]: 'Курьер',
        [this.userTypeEnum.MANAGER]: 'Управляющий',
        [this.userTypeEnum.DELIVERY_MANAGER]: 'Администратор доставки'
      }),
      (this.userTypes = Object.keys(this.userTypeName).map(v => {
        return { value: Number(v), title: this.userTypeName[Number(v)] }
      }))
  }
}
